module.exports = __webpack_public_path__ + "img/kir_yes.a7a3deda.png";